/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

/**
 * 日本の国内電話番号形式かどうかをチェック
 * 0始まり（09012345678）と0なし（9012345678）の両方に対応
 * @param {string} input - チェックする文字列
 * @returns {boolean} 日本の国内電話番号形式の場合true
 */
export const isJapanesePhoneNumber = (input) => {
    if (!input) return false;
    const phonePattern = /^0?[1-9][0-9]{8,9}$/;
    return phonePattern.test(input);
};

/**
 * 日本の国内電話番号形式をE.164国際形式に変換
 * 例: 09012345678 → +819012345678
 * 例: 9012345678  → +819012345678
 * @param {string} phone - 国内電話番号
 * @returns {string} E.164形式の電話番号
 */
export const formatPhoneNumberForJapan = (phone) => {
    if (!phone) return phone;
    // 先頭の0を除去して+81を付与
    const withoutLeadingZero = phone.startsWith('0') ? phone.substring(1) : phone;
    return `+81${withoutLeadingZero}`;
};

/**
 * E.164国際形式の電話番号を日本の国内形式に変換（表示用）
 * 例: +819012345678 → 09012345678
 * @param {string} phoneNumber - E.164形式の電話番号
 * @returns {string} 国内形式の電話番号（0始まり）
 */
export const displayPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    if (phoneNumber.startsWith('+81')) {
        const afterCountryCode = phoneNumber.substring(3);
        return afterCountryCode.startsWith('0') ? afterCountryCode : '0' + afterCountryCode;
    }
    return phoneNumber;
};

